export type ContentTemplate = "article" | "opening-reference" | "news";

export function getPostTopic(post: any): string {
  return (
    post?._sys?.breadcrumbs?.[0] ||
    post?.category?.slug ||
    ""
  ).toLowerCase();
}

export function getContentTemplate(post: any): ContentTemplate {
  if (
    post?.template === "article" ||
    post?.template === "opening-reference" ||
    post?.template === "news"
  ) {
    return post.template;
  }

  const topic = getPostTopic(post);
  if (topic === "news") {
    return "news";
  }

  if (topic === "openings" && post?.subtopic === "chess-openings-by-name") {
    return "opening-reference";
  }

  return "article";
}

export function getTopicHref(topic?: string | null): string {
  if (!topic) return "/guides";
  return topic === "news" ? "/news" : `/${topic}`;
}

export function getPostHref(
  post: any,
  mode: "guides" | "news" = "guides",
): string {
  const topic = getPostTopic(post);
  const slug = post?._sys?.breadcrumbs?.[1] || post?.slug;

  if (!slug) return mode === "news" ? "/news" : "/guides";
  if (mode === "news" || topic === "news") return `/news/${slug}`;
  if (!topic) return "/guides";

  return `/${topic}/${slug}`;
}
